import { unityContext } from "components/UnityComponent/UnityComponent";

export const unityEnableUnityDebugMode = () => {
  (window as { [key: string]: any })["enable_debug_mode"] = async () => {
    unityContext.send("NetworkManager", "EnableDebugMode");
  };
};
